window.addEventListener('alpine:init', () => {
  if (window.global.registeredAlpineComponents['productFormSubmitButton']) return;

  function productFormSubmitButton(data = {}) {
    return {
      ...data,

      init() {
        if (this.isPreorder && this.preorderQuantity) {
          Alpine.effect(() => {
            const cart = Alpine.store('cart').data;

            const cartVariantQuantity = (cart?.items || [])
              .filter((item) => item.variant_id === this.variantId)
              .reduce((sum, item) => sum + item.quantity, 0);

            this.variantAvailable = cartVariantQuantity < this.preorderQuantity;
          });
        }
      }
    };
  };

  Alpine.data('productFormSubmitButton', productFormSubmitButton);

  window.global.registeredAlpineComponents['productFormSubmitButton'] = true;
});
